import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveHistoryRoute } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { TextInput } from '../../components/common/components'
import { setHistoryResult, searchHistory, cancelReserve } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import { weeks } from '../../utils/utils'

const genderName = {
    "M":"男",
    "F": "女"
}

export default function HistoryResult() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveHistoryRoute, (o) => o.path === location.pathname)

    const result = (useSelector(state => state.getIn(["reserveHistory", "result"]))).toJS()

    useEffect(() => {
        if (result.length === 0) {
            Swal.fire("無查詢結果", "", "info")
            history.push('/search')
        }
        return () => {
            dispatch(setHistoryResult({ value: [] }))
        }
    }, [])



    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {

    }

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveHistoryRoute[idx].name}</title>
        </Helmet>
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveHistoryRoute[idx].name}
            </Typography>
            {_.map(result, (item, key) => {
                return <Box key={item.TICKET_NO} mt={5}>
                    <Typography variant="body1" gutterBottom>
                        預約項目：{item.CODE_NAME}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        預約日期：{item.SCHD_DATE_STR}({weeks[item.DAYS_STR]})
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        開診時間：{item.SCHD_TIME_STR}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        最後報到時間：{item.DEADLINE_ARRIVAL_TIME_STR}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{color:'red'}}>
                        報到地點：{item.AREA_NAME}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red', whiteSpace: "pre-line" }}>
                        注意事項：{item.NOTES}
                    </Typography>
                    {/* <Typography variant="body1" gutterBottom>
                        預約代號：{item.TICKET_NO}
                    </Typography> */}
                    <Typography variant="body1" gutterBottom>
                        身分證字號：{item.PAT_IDNO}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        性別：{item.SEX?genderName[item.SEX]:""}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        聯絡電話：{item.TEL_MOBILE}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        生日：{item.BIRTHDAY}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        電子郵件：{item.EMAIL}
                    </Typography>



                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            variant="contained"
                            style={{ margin: "20px" }}
                            onClick={() => { dispatch(cancelReserve(item.PAT_IDNO, item.BIRTHDAY, item.TICKET_NO, item.TOKEN)) }}
                        >
                            取消預約
                        </Button>
                    </div>

                    {result.length - 1 === key || <hr />}
                </Box>
            })}
            <Typography variant="body1" gutterBottom style={{ lineHeight: "2", padding: "10px 0" }}>
                報名注意需知：<br/>
                【報名方式】當天務必攜帶健保卡及身分證，現場查驗符合資格後進行報名。<br/>
                【成人預防保健(報名)】如欲當日即進行抽血，請於檢查前8小時保持空腹。<br/>
                【成人預防保健(回診)】<br/>
                    * 成人預防保健二階回診含醫師理學檢查、慢性疾病風險評估建議、健康諮詢、血液及尿液檢查報告結果說明，未提供五癌篩檢報告諮詢。<br/>
                    {/* * 若欲申請成人健檢紙本報告，請至 B1中央櫃台申請。<br/> */}

                【肺癌篩檢(免費)】符合家族史的民眾報名請攜帶肺癌家人的姓名、身分證號碼、出生年月日等資料，當日報名完成後，將再安排檢查時間。<br/>
                【大腸癌篩檢】符合家族史資格的民眾，請攜帶大腸癌家人之姓名、身分證號碼、出生年月日等資料，以供報名填表所需。<br/>
                【子宮頸癌篩檢】請避開生理期間。<br/>




            </Typography>
        </Paper>
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px" }}
            onClick={() => { history.push('/search') }}
        >
            回查詢頁
        </Button>
    </Box>
}